export class InvalidPathError extends Error {}
